import { initStitchesBackgroundColorListeners, doAjax, initColorSelect, fakeSelected } from './helper'
import { getCustomizedSeatImage } from './imagesLogicController'

const initRSStickungSelectLogic = () => {
	const seatSelect = document.querySelector("input[name=frontseat]").value;
	const selectedLeatherColor = document.querySelector("input[name=frontseatcolor]").value;
	const selectedStitchColor = document.querySelector("input[name=frontseatstitch]").value;

	const seatLeatherImg = document.querySelector('.display .image-wrap .item')
	const seatStitchImg = document.querySelector('.display .image-wrap .overlay')
	const seatBieseImg = document.querySelector('.display .image-wrap .overlay-2')
	const seatEmbossingImg = document.querySelector('.display .image-wrap .overlay-3')

	const embossingTiles = document.querySelectorAll('.embossing-tiles .color')

	const checkboxEmbossing = document.querySelector("input[name=embossing]");
	const embossing = document.getElementById("toggle_embossing");

	initColorSelect()
	onFirstLoadSetImages(seatLeatherImg, seatStitchImg, seatEmbossingImg, seatSelect);

	let frontseatComponents = ['headrestSidePressedColor','headrestFrontPressedColor','shoulderArchPressedColor',
	'shoulderBolstersPressedColor','thighPadPressedColor','seatCenterPanelPressedColor','seatSideBolstersInsidePressedColor','circumferentialBandPressedColor','backrestTopPressedColor',
	'seatSideBolstersOutsidePressedColor','contrastStitchingSidePressedColor','contrastStitchingCenterPressedColor','contrastStitchingHoneycombQuiltingPressedColor',
	'contrastStitchingDiamondQuiltingPressedColor','embossingPressedColor','biesePressedColor','seatCoverPressedColor','contrastStitchingSeatCoverPressedColor',
	'headrestFront2PressedColor','seatCenterPanel2PressedColor','seatSportStripePressedColor','backrestCoverPressedColor','seatCover2PressedColor']

	frontseatComponents.forEach(component => {
		checkCustomizedComponentsOnLoading('frontSeat', component)
	});
	
		checkboxEmbossing.addEventListener('change', function() {
			if (this.checked) {
				embossing.style.display = "block";
				setEmbossingImg(seatEmbossingImg,seatSelect) 
				doAjax({
					choose_seat_embossing: 1
				})
			} else {
				embossing.style.display = "none";
				setEmptyImg(seatEmbossingImg)
				doAjax({
					choose_seat_embossing: 0
				})
			}
		});


	embossingTiles?.forEach(element => {
		//when on click on embossing tile
		element.addEventListener("click", function (e) {
			const selectedEmbossingColor = document.querySelector('.embossing-tiles .color.selected input').value
			seatEmbossingImg.src = getCustomizedSeatImage('frontSeat', 'embossingColor', selectedEmbossingColor, seatSelect)
			//save seat state 
			saveSeatWithAjax(selectedLeatherColor, selectedStitchColor, selectedEmbossingColor)
		});
	});

	var checked_embossing = $('#frontseat-embossing-tiles .color.seam.selected span').text();

	$('#embossing_headline').html(checked_embossing);
	$('#embossing_label').animate({ opacity: 1 }, 150);

	$("#frontseat-embossing-tiles input").click(function () {
		checked_embossing = $('#frontseat-embossing-tiles .color.seam.selected span').text();
		$('#embossing_headline').html(checked_embossing);
		$('#embossing_label').animate({ opacity: 1 }, 150);
		document.getElementById("panel-4").checked = false;
	});

}

function setEmptyImg(empyImg) {
	empyImg.src = 'img/03_sitze/front_empty.png'
}

function setEmbossingImg(seatEmbossingImg,seatSelect) {
	const selectedEmbossingColor = document.querySelector('.embossing-tiles .color.selected input').value
	seatEmbossingImg.src = getCustomizedSeatImage('frontSeat', 'embossingColor', selectedEmbossingColor, seatSelect)
}

function onFirstLoadSetImages(seatLeatherImg, seatStitchImg, seatEmbossingImg, seatSelect) {
	const selectedLeatherColor = document.querySelector("input[name=frontseatcolor]").value;
	const selectedStitchColor = document.querySelector("input[name=frontseatstitch]").value;
	const selectedEmbossingColor = document.querySelector('.embossing-tiles .color.selected input').value
	
	seatEmbossingImg.src = aeo['images']['frontseat_'+seatSelect+'_embossing_color'][selectedEmbossingColor];
	seatLeatherImg.src = aeo['images']['frontseat_'+seatSelect+'_color'][selectedLeatherColor];
	seatStitchImg.src = aeo['images']['frontseat_'+seatSelect+'_stitch_color'][selectedStitchColor];
}

function saveSeatWithAjax(seatColor,seatStitch,embossingColor) {
	doAjax({
		'frontSeatComponent' : true,
		'frontSeatPressedEmbossingColor': embossingColor
	}, (response) => {
	})
	doAjax({
		'frontSeatComponent' : true,
		'embossingPressedColor': embossingColor
	}, (response) => {
	})
	doAjax({
		'backSeatComponent' : true,
		'frontSeatPressedEmbossingColor': embossingColor
	}, (response) => {
	})
	doAjax({
		'backSeatComponent' : true,
		'embossingPressedColor': embossingColor
	}, (response) => {
	})
}

function getFrontSeatComponentDotId(component) {
	switch (component) {
		case 'headrestSidePressedColor': return 'headrestSide'
		case 'headrestFrontPressedColor': return 'headrestFront'
		case 'shoulderArchPressedColor': return 'shoulderArch'
		case 'shoulderBolstersPressedColor': return 'shoulderBolsters'
		case 'thighPadPressedColor': return 'thighPad'
		case 'seatCenterPanelPressedColor': return 'seatCenterPanel'
		case 'seatSideBolstersInsidePressedColor': return 'seatSideBolstersInside'
		case 'circumferentialBandPressedColor': return 'circumferentialBand'
		case 'seatSideBolstersOutsidePressedColor': return 'seatSideBolstersOutside'
		case 'backrestTopPressedColor': return 'backrestTop'
		case 'contrastStitchingSidePressedColor': return 'contrastStitchingSide'
		case 'contrastStitchingCenterPressedColor': return 'contrastStitchingCenter'
		case 'contrastStitchingHoneycombQuiltingPressedColor': return 'contrastStitchingHoneycombQuilting'
		case 'contrastStitchingDiamondQuiltingPressedColor': return 'contrastStitchingDiamondQuilting'
		case 'embossingPressedColor': return 'embossing'
		case 'biesePressedColor': return 'biese'
		case 'seatCoverPressedColor': return 'seatCover'
		case 'contrastStitchingSeatCoverPressedColor': return 'contrastStitchingSeatCover'
		case 'headrestFront2PressedColor': return 'headrestFront2'
		case 'seatCenterPanel2PressedColor': return 'seatCenterPanel2'
		case 'seatSportStripePressedColor': return 'seatSportStripe'
		case 'backrestCoverPressedColor': return 'backrestCover'
		case 'seatCover2PressedColor': return 'seatCover2'
		default:
			break;
	}
}

function replaceImage(seatType, component, colorCode, seatSelect) {	
	if (document.getElementById(component)) {
		component = getFrontSeatComponentDotId(component)
		if (component == 'contrastStitchingSeatCover' || component == 'seatCover') {
			var imageSource = aeo['paths']['frontseat_'+seatSelect+'_YQN_component_path'][colorCode] + aeo['components']['seat_components_screen_default'][component] + '.png';
		} else {
			var imageSource = aeo['paths']['frontseat_'+seatSelect+'_component_path'][colorCode] + aeo['components']['seat_components_screen_default'][component] + '.png';
		}
		let imageArray = document.getElementById('seat-single').querySelectorAll('.wrapper-relative img.overlay')
		const imageId = component + '-img'
		let imageExists = false;
		imageArray.forEach(element => {
			if (element.id != null && element.id == imageId) {
				imageExists = true
				element.src = imageSource
			}
		});
		if (!imageExists && imageArray.length > 0) {
			let newImage = document.createElement('IMG')
			newImage.classList.add('overlay')
			newImage.id = component + '-img'
			imageArray[imageArray.length - 1].insertAdjacentElement('afterend', newImage)
			newImage.src = imageSource
		}
	}
	
}

/** Loads already customized components */
function checkCustomizedComponentsOnLoading(seatType, component) {
	const seatSelect = document.querySelector("input[name=frontseat]").value; 
	const seatTypeNameValue = "frontseat"
	let query = `#seat-components #${component} td[name="${seatTypeNameValue}"]`
	let componentColorCode = document.querySelector(query)?.getAttribute('color-code')
	const mainSeatColorCode = document.querySelector('#picked-color td[color-code]')?.getAttribute('color-code')
	if (componentColorCode != mainSeatColorCode) {
		replaceImage(seatType, component, componentColorCode, seatSelect)
	}
}

export { initRSStickungSelectLogic };
